/**
 * 品牌前缀常量。
 *
 * 用于导出文件名、埋点/分析 key 等 snake_case 场景的品牌前缀。
 * 历史演进：parcelpanel -> parcelwill -> cwill。
 * 下次品牌变更时只需修改此处一个值即可全局生效。
 */
export const BRAND_KEY_PREFIX = "cwill_tracking"
